<template>
  <div>
    <card>
      <div slot="header" class='toolsBar'>
        <div class="leftTools"> 
          <fg-input type="text" placeholder='請輸入訂單編號,姓名,電話' v-model="searchForm.keyword" style="width:200px;" />
          <el-select class="select-default" placeholder="請選擇" v-model="searchForm.status" clearable="" style="width:140px;"> 
            <el-option v-for="i in statusOptions" class="select-default" :value="i.status" :label="i.text" :key="i.status" />
          </el-select>
          <fg-input style="width:150px;">
            <el-date-picker v-model="searchForm.startDt" type="date" placeholder="選擇日期" />
          </fg-input>
          <label style='line-height:30px;'>~</label>
          <fg-input style="width:150px;">
            <el-date-picker v-model="searchForm.endDt" type="date" placeholder="選擇日期" />
          </fg-input>
          <div>
            <l-button type="default" @click="doSearch()">搜尋</l-button>
          </div>
        </div>
        <div style="display: flex;">
          <div>
            <l-button outline class="my-auto" type="warning" @click="batchChangeStatus()">批次修改狀態</l-button>
          </div>

          <div class="mx-3"/>

          <el-select class="select-info" placeholder="請選擇" clearable="" v-model="actionForm.action" style="width:140px; padding-right: 10px;"> 
            <el-option v-for="i in actionOptions" class="select-info" :value="i.action" :label="i.text" :key="i.action" />
          </el-select>

          <div>
            <l-button type="info" @click="executeAction()">執行</l-button>
          </div>
        </div>
      </div>
      
      <div class="row">
        <div class="col-sm-12">
          <el-table :data="tableData" ref="multipleTable" >
            <el-table-column label="選取" width="80px;" type='selection' />
            <el-table-column prop="store.name" width="100px;" label="通路" />
            <el-table-column prop="orderNo" width="140px;" label="訂單編號">
              <div slot-scope="props" >
                <b class="font-weight-light">{{props.row.orderNo}}</b>
                <l-button v-if="props.row.subOrders && props.row.subOrders.length > 0" type="info btn-sm" outline @click="toggleSubOrders(props)">退/換貨展開</l-button>
              </div>
            </el-table-column>

            <el-table-column label="狀態" min-width="120px" >
              <div slot-scope="props">
                <div><b>{{getStatusText(props.row.status)}}</b> <small>({{dateText(props.row.createdAt)}})</small></div>
                <div><b>{{getDeliveryStatusText(props.row.deliveryStatus)}}</b> <small>(配送單號)</small></div>
                <div v-if="!props.row.parentId"><b>{{getPaymentStatusText(props.row.paymentStatus)}}</b> <small>({{props.row.currency.isoCode}} {{props.row.totalPrice}})</small></div>
                <div v-if="!props.row.parentId"><b>{{getInvoiceStatusTextWithAllowanceAmount(props.row)}}</b> <small>{{getInvoiceNumber(props.row)}}</small></div>
              </div>
            </el-table-column>

            <el-table-column label="方案/品項" min-width="110px" >
              <div class="td-actions justify-top" slot-scope="props" >
                <div v-bind:key="orderDetail.id" v-for='(orderDetail, orderDetailIdx) in props.row.orderDetails'>
                  <br v-if="orderDetailIdx != 0" />
                  <template v-if='orderDetail.type == 0'>
                    <div class="mt-1 mb-3" style="line-height: 0"><h6 class="d-inline">{{orderDetail.plan.name}}</h6> <p class="small font-weight-normal d-inline" v-if="!props.row.parentId">{{orderDetail.price}}{{props.row.currency.title}}</p></div>
                  </template>
                  <template v-else-if='orderDetail.type == 1'>
                    <div class="mt-1 mb-3" style="line-height: 0"><h6 class="d-inline">{{orderDetail.addpurchase.name}}</h6> <p class="small font-weight-normal d-inline" v-if="!props.row.parentId">{{orderDetail.price}}{{props.row.currency.title}}</p></div>
                  </template>

                  <template v-for='(orderGoods, orderGoodsIdx) in orderDetail.orderGoods'>
                    <div v-bind:key="orderGoodsIdx + '---' + orderGoods.id">
                      <h6 class="mt-3" v-bind:key="orderGoodsIdx + '-' + orderGoods.id">{{orderGoods.goods.name}} <b v-if="!(props.row.parentId)">{{orderGoods.quantity}}份</b> <p v-if="orderGoods.status != 0" class="d-inline ml-2 px-2 small font-weight-bold" style="background: red; color: white;">{{getOrderGoodsStatusText(orderGoods.status)}}</p></h6>
                      <template v-for='(orderItem, orderItemIdx) in orderGoods.orderItems'>
                        <div v-if="orderItem.quantity != 0" style="line-height: 0;" v-bind:key="orderItemIdx + '-' + orderGoodsIdx + '-' + orderItem.id"><p class="small d-inline">- {{orderItem.item.name}} * {{orderItem.quantity}}</p><p v-if="orderItem.status != 0" class="d-inline ml-2 px-2 small font-weight-bold" style="background: red; color: white;">{{getOrderGoodsStatusText(orderItem.status)}}</p></div>
                      </template>
                    </div>
                  </template>
                </div>
              </div>
            </el-table-column>
            <el-table-column prop="status" min-width="70px" label="付款/配送">
              <div v-if="!props.row.parentId" slot-scope="props">
                <div class="font-weight-light">{{getPaymentMethodText(props.row.paymentMethod)}}</div>
                <div class="font-weight-light">{{getDeliveryTypeText(props.row.deliveryType)}}</div>
              </div>
            </el-table-column>
            <el-table-column min-width="120px" label="客戶資料">
              <div v-if="!props.row.parentId" class="td-actions font-weight-light" slot-scope="props">
                <div><small>姓名: </small>{{props.row.name}}</div>
                <div><small>電話: </small>{{props.row.mobile}}</div>
                <div><small>地址: </small>{{getAddressText(props.row)}}</div>
                <div><small>Email: </small>{{props.row.email}}</div>
                <div><small>發票類型: </small>{{getInvoiceText(props.row.invoiceType)}}</div>
              </div>
            </el-table-column>
            <el-table-column label="客戶備註">
              <div v-if="!props.row.parentId" slot-scope="props">
                <small>{{props.row.note}}</small>
              </div>
            </el-table-column>
            <el-table-column label="系統備註">
              <div v-if="!props.row.parentId" slot-scope="props">
                <small>{{props.row.systemNote}}</small>
              </div>
            </el-table-column>
            <el-table-column label="Actions">
              <div class="td-actions" slot-scope="props">
                <a v-tooltip.top-center="'修改'" class="btn btn-primary btn-link btn-xs" @click="handleEdit(props.row)" v-show="props.row.parentId == null">
                  <i class="fa fa-edit" />
                </a>

                <a v-tooltip.top-center="'處理完成'" class="btn btn-primary btn-link btn-xs" @click="handleRenew(props)" v-show="props.row.status === 1">
                  <i class="fa fa-retweet" />
                </a>

                <a v-tooltip.top-center="'缺貨'" class="btn btn-primary btn-link btn-xs" @click="handleStock(true, props)"
                  v-show="(props.row.status === 0 && props.row.deliveryStatus == 101)">
                  <i class="fa fa-hand-paper-o" />
                </a>

                <a v-tooltip.top-center="'可出貨'" class="btn btn-primary btn-link btn-xs" @click="handleStock(false, props)"
                  v-show="(props.row.status === 3 && props.row.deliveryStatus == 102)">
                  <i class="fa fa-thumbs-o-up" />
                </a>

                <a v-tooltip.top-center="'上傳'" class="btn btn-primary btn-link btn-xs" @click="handleUpload(props)"
                  v-show="(props.row.status === 0 && props.row.deliveryStatus == 101)">
                  <i class="fa fa-upload" />
                </a>

                <a v-tooltip.top-center="'出貨'" class="btn btn-primary btn-link btn-xs" @click="handleDeliver(props)"
                  v-show="(props.row.status === 2 && props.row.deliveryStatus == 104)">
                  <i class="fa fa-truck" />
                </a>

                <a v-tooltip.top-center="'拒收'" class="btn btn-danger btn-link btn-xs" @click="handleDeny(props)"
                  v-show="(props.row.status === 2 && props.row.deliveryStatus == 105)">
                  <i class="fa fa-ban" />
                </a>

                <a v-tooltip.top-center="'其他'" class="btn btn-warning btn-link btn-xs" @click="handleOthers(props)"
                  v-show="(props.row.status === 2 && props.row.deliveryStatus == 105)">
                  <i class="fa fa-warning" />
                </a>

                <a v-tooltip.top-center="'到貨'" class="btn btn-primary btn-link btn-xs" @click="handleArrive(props)"
                  v-show="(props.row.status === 2 && props.row.deliveryStatus == 105)">
                  <i class="fa fa-at" />
                </a>

                <a v-tooltip.top-center="'退/換貨'" class="btn btn-primary btn-link btn-xs" @click="handleNewReturn(props.row)"
                  v-show="((props.row.status === 4 || props.row.status === 412 || props.row.status === 413) && props.row.deliveryStatus == 106)">
                  <i class="fa fa-refresh" />
                </a>

                <a v-tooltip.top-center="'上傳'" class="btn btn-primary btn-link btn-xs" @click="handleUpload(props)"
                  v-show="(props.row.status === 400 || props.row.status == 401)">
                  <i class="fa fa-upload" />
                </a>

                <a v-tooltip.top-center="'退/換貨完成'" class="btn btn-primary btn-link btn-xs" @click="handleReturnFinish(props)"
                  v-show="(props.row.status === 403 || props.row.status === 404)">
                  <i class="fa fa-at" />
                </a>

                <a v-tooltip.top-center="'付款'" class="btn btn-primary btn-link btn-xs" @click="handlePayment(props)"
                  v-show="props.row.parentId == null && props.row.paymentStatus === 200">
                  <i class="fa fa-money" />
                </a>

                <a v-tooltip.top-center="'開發票'" class="btn btn-primary btn-link btn-xs" @click="handleIssueInvoice(props)"
                  v-show="(props.row.parentId == null && props.row.paymentStatus === 202 && props.row.invoiceStatus === 301)">
                  <i class="fa fa-file-text-o" />
                </a>

                <a v-tooltip.top-center="'作廢發票'" class="btn btn-primary btn-link btn-xs" @click="handleCancelInvoice(props)"
                  v-show="(props.row.parentId == null && props.row.paymentStatus === 202 && (props.row.invoiceStatus === 302 || props.row.invoiceStatus === 306))">
                  <i class="fa fa-file-excel-o" />
                </a>

                <a v-tooltip.top-center="'折讓'" class="btn btn-primary btn-link btn-xs" @click="handleAllowance(props.row)"
                  v-show="(props.row.parentId == null && props.row.paymentStatus === 202 && (props.row.invoiceStatus === 302 || props.row.invoiceStatus === 306))">
                  <i class="fa fa-file-code-o" />
                </a>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
        <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <div class="">
            <p class="card-category" />
          </div>
          <l-pagination class="pagination-no-border"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        @input='handleIndexChange'
                        :total="pagination.total" />
        </div>
    </card>
    <el-dialog center title="新增退/換貨" :visible.sync="modals.returnDialog">
      <!-- <el-table :data="returnOrderData" :span-method="objectSpanMethod" ref="multipleTable"> -->
      <el-table :data="returnOrderData">
        <el-table-column label="方案" prop="planName" />
        <el-table-column label="貨品">
          <div slot-scope="props">
            {{props.row.orderGoods.goods.name}}
          </div>
        </el-table-column>
        <el-table-column label="商品">
          <div slot-scope="props">
            <div style="line-height: normal;">{{props.row.orderItem.item.name}} ({{props.row.orderItem.id}})</div>
          </div>
        </el-table-column>
        <el-table-column label="數量">
          <div slot-scope="props">
            <b class="font-weight-light">{{props.row.orderItem.quantity}}</b>
          </div>
        </el-table-column>
        <el-table-column label="狀態">
          <div slot-scope="props">
            <b>{{getOrderGoodsStatusText(props.row.orderItem.status)}}</b>
          </div>
        </el-table-column>
        <el-table-column label="設定">
          <div slot-scope="props">
            <el-select
              class="select-default"
              :disabled="props.row.orderItem.status != 0 && props.row.orderItem.status != 4"
              placeholder="請選擇"
              :name="'amnt_' + props.$index"
              v-model="props.row.amount"
              v-validate="'required'" >
              <el-option v-for="i in props.row.amountArray" class="select-default" :value="i.value" :label="i.value" :key="'amount_'+ i.value" />
            </el-select>
          </div>
        </el-table-column>
      </el-table>
      <hr />
      <el-select
        class="select-default mb-3"
        data-vv-as="退換貨選項"
        placeholder="請選擇"
        name="returnType"
        v-model="returnForm.type"
        :error="getError('')"
        v-validate="'required'">
        <el-option v-for="i in returnTypeOptions" class="select-default" :value="i.id" :label="i.text" :key="'returnType'+ i.id" />
      </el-select>
      <fg-input label="收件人姓名"
                type="text"
                name="receiverName"
                data-vv-as="收件人姓名"
                v-model="returnForm.receiverName"
                v-validate="'required'"     
                :error="getError('receiverName')"
                required />
      <fg-input label="收件人地址"
                type="text"
                name="receiverAddress"
                data-vv-as="收件人地址"
                v-model="returnForm.receiverAddress"
                :error="getError('receiverAddress')"
                v-validate="'required'"
                required />
      <fg-input label="收件人電話"
                type="text"
                name="receiverPhone"
                data-vv-as="收件人電話"
                v-model="returnForm.receiverPhone"
                :error="getError('receiverPhone')"
                v-validate="'required'"
                required />
      <div class="text-right">
        <button type="submit" @click.prevent="validateReturn" class="btn btn-fill btn-info align-right">建立</button>
      </div>
    </el-dialog>
    <el-dialog center title="批次修改訂單狀態" :visible.sync="modals.changeStatusDialog">
      <fg-input
        label="欲改變狀態的訂單編號(以逗號分隔)">
        <el-input
          rows="8"
          type="textarea"
          name="orders"
          data-vv-as="欲改變狀態的訂單編號"
          v-model="orderStatusForm.orders"
          :error="getError('')"
          v-validate="'required'"
          required />
        <div class='text-danger invalid-feedback' style="display:block" v-show="errors.has('orders')">{{ errors.first('orders') }}</div>
      </fg-input>

      <div class="form-group mb-3">
        <label>欲改變至狀態 *</label>
        <el-select
          class="select-default"
          data-vv-as="欲改變至狀態"
          placeholder="請選擇"
          name="newStatus"
          v-model="orderStatusForm.newStatus"
          :error="getError('')"
          v-validate="'required'">
          <el-option v-for="i in availableStatus" class="select-default" :value="i.status" :label="i.text" :key="'newStatus'+ i.status" />
        </el-select>
        <div class='text-danger invalid-feedback' style="display:block" v-show="errors.has('newStatus')">{{ errors.first('newStatus') }}</div>
      </div>
      
      <!-- <hr />
      
      <fg-input label="收件人姓名"
                type="text"
                name="receiverName"
                data-vv-as="收件人姓名"
                v-model="returnForm.receiverName"
                v-validate="'required'"     
                :error="getError('receiverName')"
                required />
      <fg-input label="收件人地址"
                type="text"
                name="receiverAddress"
                data-vv-as="收件人地址"
                v-model="returnForm.receiverAddress"
                :error="getError('receiverAddress')"
                v-validate="'required'"
                required />
      <fg-input label="收件人電話"
                type="text"
                name="receiverPhone"
                data-vv-as="收件人電話"
                v-model="returnForm.receiverPhone"
                :error="getError('receiverPhone')"
                v-validate="'required'"
                required /> -->
      <div class="text-right mt-3">
        <button type="submit" @click.prevent="validateChangeOrderStatus" class="btn btn-fill btn-info align-right">進行修改</button>
      </div>
    </el-dialog>
    <el-dialog center title="新增折讓單" :visible.sync="modals.allowanceDialog">
      <el-table :data="allowanceOrderData">
        <el-table-column label="方案" prop="planName" />
        <el-table-column label="貨品">
          <div slot-scope="props">
            {{props.row.orderGoods.goods.name}}
          </div>
        </el-table-column>
        <el-table-column label="商品">
          <div slot-scope="props">
            <div style="line-height: normal;">{{props.row.orderItem.item.name}} ({{props.row.orderItem.id}})</div>
          </div>
        </el-table-column>
        <el-table-column label="數量">
          <div slot-scope="props">
            <b class="font-weight-light">{{props.row.orderItem.quantity}}</b>
          </div>
        </el-table-column>
        <el-table-column label="狀態">
          <div slot-scope="props">
            <b>{{getOrderGoodsStatusText(props.row.orderItem.status)}}</b>
          </div>
        </el-table-column>
        <el-table-column label="設定數量">
          <div slot-scope="props">
            <el-select
              class="select-default"
              :disabled="props.row.orderItem.status != 0 && props.row.orderItem.status != 4"
              placeholder="請選擇"
              :name="'a_amnt_' + props.$index"
              v-model="props.row.amount"
              v-validate="'required'" >
              <el-option v-for="i in props.row.amountArray" class="select-default" :value="i.value" :label="i.value" :key="'amount_'+ i.value" />
            </el-select>
          </div>
        </el-table-column>
        <el-table-column label="含稅單價">
          <div slot-scope="props">
            <fg-input class="my-auto"
                type="number"
                data-vv-as="含稅單價"
                v-model="props.row.price"
                :name="'a_price_' + props.$index"
                :error="getError('price')"
                required />
          </div>
        </el-table-column>
      </el-table>
      
      <div class="text-right mt-3">
        <button type="submit" @click.prevent="validateAllowance" class="btn btn-fill btn-info align-right">建立</button>
      </div>
    </el-dialog>

    <el-dialog center :visible.sync="modals.editDialog">
      <div class="row">
        <label class='col-12'>訂單編號：<h5 class="d-inline font-weight-light">{{editForm.orderNo}}</h5></label>
      </div>
      <fg-input label="收件人"
                type="text"
                name="name"
                data-vv-as="收件人"
                v-model="editForm.name"
                v-validate="'required'"
                :disabled="editForm.status != statusOptions[0].status"
                :error="getError('name')"
                required />
      <div class="row ml-0 mb-3">
        <!-- <label class='mx-3 my-auto'>稱謂</label> -->
        <el-select
          class="select-default"
          data-vv-as="稱謂"
          placeholder="請選擇"
          name="returnType"
          v-model="editForm.title"
          :disabled="editForm.status != statusOptions[0].status"
          :error="getError('')"
          v-validate="'required'">
          <el-option v-for="i in editTitleOptions" class="select-default" :value="i.id" :label="i.text" :key="'editTitle'+ i.id" />
        </el-select>
      </div>
      <fg-input label="聯絡電話"
                type="text"
                name="mobile"
                data-vv-as="聯絡電話"
                placeholder='聯絡電話'
                v-model="editForm.mobile"
                :disabled="editForm.status != statusOptions[0].status"
                v-validate="'required'"     
                :error="getError('mobile')"
                required />
      <el-select
        class="select-default mb-3 mr-3"
        data-vv-as="縣市"
        placeholder="縣市"
        name="country"
        v-model="editForm.country"
        :change="countryChanged()"
        :error="getError('country')"
        :disabled="editForm.status != statusOptions[0].status"
        v-validate="'required'">
        <el-option v-for="i in countryOptions" class="select-default" :value="i.key" :label="i.text" :key="'editCountry'+ i.key" />
      </el-select>

      <el-select
        class="select-default mb-3"
        data-vv-as="區"
        placeholder="區"
        name="area"
        v-model="editForm.area"
        :error="getError('area')"
        :disabled="editForm.status != statusOptions[0].status"
        v-validate="'required'">
        <el-option v-for="i in areaOptions" class="select-default" :value="i.key" :label="i.text" :key="'editArea'+ i.key" />
      </el-select>
      
      <fg-input label="收件人地址"
                type="text"
                name="address"
                data-vv-as="收件人地址"
                v-model="editForm.address"
                :error="getError('address')"
                :disabled="editForm.status != statusOptions[0].status"
                v-validate="'required'"
                required />

      <fg-input label="電子信箱"
                type="text"
                name="email"
                data-vv-as="電子信箱"
                v-model="editForm.email"
                :error="getError('email')"
                v-validate="'required'"
                required />

      <fg-input label="客戶備註" name="note">
        <el-input type="textarea" v-model="editForm.note" />
      </fg-input>

      <fg-input label="系統備註" name="systemNote">
        <el-input type="textarea" v-model="editForm.systemNote" />
      </fg-input>

      <div class="row px-3">
        <label class="mr-5">配送方式：<b>{{getDeliveryTypeText(editForm.deliveryType)}}</b></label>
        <label>付款方式：<b>{{getPaymentMethodText(editForm.paymentMethod)}}</b></label>
      </div>

      <div class="row px-3">
        <label class="mr-5">總金額：<b >{{editForm.totalPrice}}</b></label>
        <label>幣別：<b>{{editForm.currencyTitle}}</b></label>
      </div>

      <div class="row px-3">
        <div class="my-auto pb-3">
          <label class="my-auto">發票開立方式：</label>
        </div>
        
        <el-select
          class="select-default mr-2"
          data-vv-as="發票開立方式"
          placeholder="發票開立方式"
          name="invoiceType"
          v-model="editForm.invoiceType"
          :change="invoiceTypeChanged()"
          :error="getError('invoiceType')"
          :disabled="editForm.status != statusOptions[0].status"
          v-validate="'required'">
          <el-option v-for="i in invoiceTypes" class="select-default" :value="i.type" :label="i.text" :key="'editInvoiceType'+ i.type" />
        </el-select>
        <fg-input
                type="text"
                name="invoiceInfo"
                data-vv-as="發票資訊"
                v-model="editForm.invoiceInfo"
                :error="getError('invoiceInfo')"
                :disabled="editForm.status != statusOptions[0].status"
                v-validate="editForm.invoiceType === 0 ? '' : 'required'" />
      </div>

      <div class="row px-3">
        <div class="my-auto ">
          <label class="my-auto">訂單狀態：</label>
        </div>
        
        <el-select
          class="select-default mr-3"
          data-vv-as="訂單狀態"
          placeholder="訂單狀態"
          name="status"
          v-model="editForm.status"
          :error="getError('status')"
          :disabled="editForm.status != statusOptions[0].status"
          v-validate="'required'">
          <el-option v-for="i in statusOptions" class="select-default" :value="i.status" :label="i.text" :key="'editStatus'+ i.status" />
        </el-select>
        
      </div>

      <div class="my-3 mx-0">
        <label class="d-block">付款狀態：<b>{{getPaymentStatusText(editForm.paymentStatus)}}</b></label>
        <label class="d-block">配送狀態：<b>{{getDeliveryStatusText(editForm.deliveryStatus)}}</b></label>
        <label class="d-block">發票狀態：<b>{{getInvoiceStatusText(editForm.invoiceStatus)}}</b></label>
      </div>

      <div class="text-right">
        <button type="submit" @click.prevent="validateEdit" class="btn btn-fill btn-info align-right">儲存</button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
 /* eslint-disable */ 
  import { DatePicker, Dialog, Table, TableColumn, MessageBox, Select, Option } from 'element-ui'
  import { Checkbox } from 'src/components/index'
  import { Pagination as LPagination } from 'src/components/index'
  import lib from '../../../lib'
  import tools from '../../../tools'
  import { saveAs } from 'file-saver'

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [Select.name]: Select,
      [Option.name]: Option,
      [Dialog.name]: Dialog,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Checkbox.name]: Checkbox,
      LPagination
    },
    data() {
      return {
        countryOptions: [
          {key:'TWN', text: '台灣'},
          {key:'SGP', text: 'Singapore'},
          {key:'MYS', text: 'Malaysia'},
          {key:'THA', text: 'Thailand'}
        ],
        twAreaOptions: [
          {key:'TW-KEE', text: '基隆市'},
          {key:'TW-TPE', text: '台北市'},
          {key:'TW-NWT', text: '新北市'},
          {key:'TW-TAO', text: '桃園市'},
          {key:'TW-HSZ', text: '新竹市'},
          {key:'TW-HSQ', text: '新竹縣'},
          {key:'TW-MIA', text: '苗栗縣'},
          {key:'TW-TXG', text: '台中市'},
          {key:'TW-CHA', text: '彰化縣'},
          {key:'TW-NAN', text: '南投縣'},
          {key:'TW-YUN', text: '雲林縣'},
          {key:'TW-CYI', text: '嘉義市'},
          {key:'TW-CYQ', text: '嘉義縣'},
          {key:'TW-TNN', text: '台南市'},
          {key:'TW-KHH', text: '高雄市'},
          {key:'TW-PIF', text: '屏東縣'},
          {key:'TW-TTT', text: '台東縣'},
          {key:'TW-HUA', text: '花蓮縣'},
          {key:'TW-ILA', text: '宜蘭縣'},
          {key:'TW-PEN', text: '澎湖縣'},
          {key:'TW-KIN', text: '金門縣'},
          {key:'TW-LIE', text: '連江縣'}
        ],
        editTitleOptions: [
          {id:0, text: '先生'},
          {id:1, text: '小姐'}
        ],
        returnTypeOptions: [
          {id:0, text: '退貨'},
          {id:1, text: '換貨'}
        ],
        pagination: {
          perPage: 25,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        returnOrderData: [],
        returnForm: {
          orderId: '',
          type: 0,
          receiverName: '',
          receiverAddress: '',
          receiverPhone: ''
        },
        allowanceOrderData: [],
        allowanceForm: {
          orderId: '',
          receiverName: '',
          receiverAddress: '',
          receiverPhone: ''
        },
        oldOrderVariables: {
          targetOrder: '',
          oldCountry: '',
          oldInvoiceType: -1
        },
        editForm: {
          id: '',
          orderNo: '',
          name: '',
          title: 0,
          mobile: '',
          country: '',
          area: '',
          address: '',
          email: '',
          note: '',
          systemNote: '',
          deliveryType: 0,
          paymentMethod: 0,
          totalPrice: 0,
          currencyId: 0,
          currencyTitle: '',
          invoiceType: 0,
          invoiceInfo: '',
          status: 0,
          paymentStatus: 0,
          deliveryStatus: 0,
          invoiceStatus: 0
        },
        searchForm: {
          startDt:'',
          endDt:'',
          keyword:'',
          status:'',
        },
        actionForm: {
          action:''
        },
        orderStatusForm: {
          orders: '',
          newStatus: ''
        },
        query: {
          startDt:'',
          endDt:'',
          keyword:'',
          status:'',
        },
        statusOptions:[
          { status: 0, text: '新訂單'},
          { status: 1, text: '待處理'},
          { status: 2, text: '出貨'},
          { status: 3, text: '缺貨'},
          { status: 4, text: '已到貨'},
          { status: 5, text: '訂單失敗'},
          { status: 6, text: '未完成'},
          { status: 7, text: '拒收'},
          { status: 8, text: '取消訂單'},
          { status: 9, text: '退貨中'},
          { status: 10, text: '退貨中(部份)'},
          { status: 11, text: '換貨中'},
          { status: 12, text: '已退貨'},
          { status: 13, text: '已退貨(部份)'},
          { status: 14, text: '已換貨'},
          { status: 15, text: '訂單完成'},
          { status: 400, text: '新建立-退貨'},
          { status: 401, text: '新建立-換貨'},
          { status: 402, text: '新建立-重新配送'},
          { status: 403, text: '派車中-退貨'},
          { status: 404, text: '派車中-換貨'},
          { status: 405, text: '派車中-重新配送'},
          { status: 406, text: '已完成-退貨'},
          { status: 407, text: '已完成-換貨'},
          { status: 408, text: '已完成-重新配送'},
          { status: 409, text: '失敗-退貨'},
          { status: 410, text: '失敗-換貨'},
          { status: 411, text: '失敗-重新配送'},
          { status: 412, text: '退換貨中'},
          { status: 413, text: '已退換貨'}
        ],
        deliveryStatusOptions:[
          { status: 100, text: '無'},
          { status: 101, text: '待出貨'},
          { status: 102, text: '缺貨'},
          { status: 103, text: '上傳失敗'},
          { status: 104, text: '已上傳'},
          { status: 105, text: '已出貨'},
          { status: 106, text: '已到貨'},
          { status: 107, text: '拒收'},
          { status: 108, text: '其他'},
          { status: 500, text: '無'},
          { status: 501, text: '待上傳'},
          { status: 502, text: '上傳失敗'},
          { status: 503, text: '已上傳'},
          { status: 504, text: '已退貨'},
          { status: 505, text: '已換貨'},
          { status: 506, text: '其他'}
        ],
        paymentStatusOptions:[
          { status: 200, text: '未付款'},
          { status: 201, text: '未付款(已退款)'},
          { status: 202, text: '已付款'},
          { status: 203, text: '已退款'},
          { status: 204, text: '已部份退款'},
          { status: 205, text: '付款失敗-信用卡'},
          { status: 206, text: '通路-未付款'},
          { status: 207, text: '通路-已付款'}
        ],
        invoiceStatusOptions:[
          { status: 300, text: '未開立'},
          { status: 301, text: '待開立'},
          { status: 302, text: '已開立'},
          { status: 303, text: '待作廢'},
          { status: 304, text: '待折讓'},
          { status: 305, text: '已作廢'},
          { status: 306, text: '已折讓'},
          { status: 307, text: '開立失敗'},
          { status: 308, text: '廠商開立'}
        ],
        actionOptions:[
          { action: 1, text: '檢查訂單'},
          { action: 2, text: '轉待出貨'},
          { action: 3, text: '匯出訂單'}
        ],
        deliveryTypes:[
          { type: 1, text: '宅配'}
        ],
        invoiceTypes:[
          { type: 0, text: '捐贈'},
          { type: 1, text: '電子信箱'},
          { type: 2, text: '手機條碼'},
          { type: 3, text: '自然人憑證'},
          { type: 4, text: '統一編號'}
        ],
        paymentMethods:[
          { method: 1, text: '貨到付款'},
          { method: 2, text: '信用卡付款(台幣)'}
        ],
        availableStatus:[
          { status: 0, text: '新訂單'},
          { status: 1, text: '待處理'},
          { status: 2, text: '出貨'},
          { status: 3, text: '缺貨'},
          { status: 4, text: '已到貨'},
          // { status: 5, text: '訂單失敗'},
          // { status: 6, text: '未完成'},
          { status: 7, text: '拒收'},
          // { status: 8, text: '取消訂單'},
          // { status: 9, text: '退貨中'},
          // { status: 10, text: '退貨中(部份)'},
          // { status: 11, text: '換貨中'},
          // { status: 12, text: '已退貨'},
          // { status: 13, text: '已退貨(部份)'},
          // { status: 14, text: '已換貨'},
          // { status: 15, text: '訂單完成'},
          // { status: 400, text: '新建立-退貨'},
          // { status: 401, text: '新建立-換貨'},
          // { status: 402, text: '新建立-重新配送'},
          // { status: 403, text: '派車中-退貨'},
          // { status: 404, text: '派車中-換貨'},
          // { status: 405, text: '派車中-重新配送'},
          // { status: 406, text: '已完成-退貨'},
          // { status: 407, text: '已完成-換貨'},
          // { status: 408, text: '已完成-重新配送'},
          // { status: 409, text: '失敗-退貨'},
          // { status: 410, text: '失敗-換貨'},
          // { status: 411, text: '失敗-重新配送'},
          { status: 412, text: '退換貨中'},
          { status: 413, text: '已退換貨'}
        ],
        cuser: null,
        modals: {
          returnDialog: false,
          editDialog: false,
          allowanceDialog: false,
          changeStatusDialog: false
        },
        // pos: 0,
        // spanArr0:[],
        // spanArr1:[],
        tableData: [],
        orderGoodsStatusOptions:[
          { status: 0, text: '無'},
          { status: 1, text: '退貨中'},
          { status: 2, text: '已退貨'},
          { status: 3, text: '換貨中'},
          { status: 4, text: '已換貨'}
        ]
      }
    },
    async mounted() {
      await this.getData()
    },
    watch: {
      'pagination.currentPage': async function(val) {
      }
    },
    computed: {
      areaOptions() {
        var array = []
        if (this.editForm.country == this.countryOptions[0].key) {
          array = this.twAreaOptions
        } else if (this.editForm.country == this.countryOptions[1].key) {
          array.push({key:'SGP', text: 'Singapore'})
        } else if (this.editForm.country == this.countryOptions[2].key) {
          array.push({key:'MYS', text: 'Malaysia'})
        } else if (this.editForm.country == this.countryOptions[3].key) {
          array.push({key:'THA', text: 'Thailand'})
        }
        return array
      }
    },
    methods: {
      // getSpanArr0(data) {
      //   this.spanArr0 = []
      //   for (var i = 0; i < data.length; i++) {
      //     if (i === 0) {
      //       this.spanArr0.push(1)
      //       this.pos = 0
      //     } else {
      //       // Determine if the current element is the same as the previous element
      //       if (data[i].planName === data[i - 1].planName) {
      //         this.spanArr0[this.pos] += 1
      //         this.spanArr0.push(0)
      //       } else {
      //         this.spanArr0.push(1)
      //         this.pos = i;
      //       }
      //     }
      //   }

      //   console.log('this.spanArr0: ', this.spanArr0)
      // },
      // getSpanArr1(data) {
      //   this.spanArr1 = []
      //   for (var i = 0; i < data.length; i++) {
      //     if (i === 0) {
      //       this.spanArr1.push(1)
      //       this.pos = 0
      //     } else {
      //       // Determine if the current element is the same as the previous element
      //       if (data[i].orderGoods.goods.name === data[i - 1].orderGoods.goods.name) {
      //         this.spanArr1[this.pos] += 1
      //         this.spanArr1.push(0)
      //       } else {
      //         this.spanArr1.push(1)
      //         this.pos = i;
      //       }
      //     }
      //   }

      //   console.log('this.spanArr1: ', this.spanArr1)
      // },
      // objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      //   if (columnIndex === 0) {
      //     const _row = this.spanArr0[rowIndex]
      //     const _col = _row > 0 ? 1 : 0
          
      //     return {
      //       rowspan: _row,
      //       colspan: _col
      //     }
      //   } else if (columnIndex === 1) {
      //     const _row = this.spanArr1[rowIndex]
      //     const _col = _row > 0 ? 1 : 0
          
      //     return {
      //       rowspan: _row,
      //       colspan: _col
      //     }
      //   }
      // },

      invoiceTypeChanged() {
        if (this.editForm.invoiceType != this.oldOrderVariables.oldInvoiceType) {
          this.oldOrderVariables.oldInvoiceType = this.editForm.invoiceType
          if (this.editForm.invoiceInfo != '') {
            this.editForm.invoiceInfo = ''
          }
        }
      },
      countryChanged() {
        if (this.editForm.country && this.editForm.country != this.oldOrderVariables.oldCountry) {
          this.oldOrderVariables.oldCountry = this.editForm.country
          if (this.editForm.area != this.areaOptions[0].key) {
            this.editForm.area = this.areaOptions[0].key
          }
        }
      },
      getAddressText(order) {
        return this.getCountryText(order.country) + this.getAreaText(order.country, order.area) + order.address
      },
      getCountryText(key) {
        for (var i = 0; i < this.countryOptions.length; i++) {
          if (this.countryOptions[i]['key'] == key) {
            return this.countryOptions[i]['text']
          }
        }
        
        return ''
      },
      getAreaText(country, key) {
        var array = []
        if (country == this.countryOptions[0].key) {
          array = this.twAreaOptions
        } else if (country == this.countryOptions[1].key) {
          array.push({key:'SGP', text: 'Singapore'})
        } else if (country == this.countryOptions[2].key) {
          array.push({key:'MYS', text: 'Malaysia'})
        } else if (country == this.countryOptions[3].key) {
          array.push({key:'THA', text: 'Thailand'})
        }

        for (var i = 0; i < array.length; i++) {
          if (array[i]['key'] == key) {
            return array[i]['text']
          }
        }
        
        return ''
      },

      toggleSelected() {
        var temp = []
        temp = this.tableValues.map(function (item) { return item.action })
        this.checkedItems = (this.allSelected === false) ? temp : []
      },
      getOrderGoodsStatusText(status) {
        for (var i = 0; i < this.orderGoodsStatusOptions.length; i++) {
          if (this.orderGoodsStatusOptions[i]['status'] == status) {
            return this.orderGoodsStatusOptions[i]['text']
          }
        }
        return ''
      },
      getStatusText(status) {
        for (var i = 0; i < this.statusOptions.length; i++) {
          if (this.statusOptions[i]['status'] == status) {
            return this.statusOptions[i]['text']
          }
        }
        return ''
      },
      getDeliveryStatusText(status) {
        for (var i = 0; i < this.deliveryStatusOptions.length; i++) {
          if (this.deliveryStatusOptions[i]['status'] == status) {
            return this.deliveryStatusOptions[i]['text']
          }
        }
        return ''
      },
      getPaymentStatusText(status) {
        for (var i = 0; i < this.paymentStatusOptions.length; i++) {
          if (this.paymentStatusOptions[i]['status'] == status) {
            return this.paymentStatusOptions[i]['text']
          }
        }
        return ''
      },
      getInvoiceStatusText(status) {
        for (var i = 0; i < this.invoiceStatusOptions.length; i++) {
          if (this.invoiceStatusOptions[i]['status'] == status) {
            return this.invoiceStatusOptions[i]['text']
          }
        }
        return ''
      },
      getInvoiceStatusTextWithAllowanceAmount(order) {
        for (var i = 0; i < this.invoiceStatusOptions.length; i++) {
          if (this.invoiceStatusOptions[i]['status'] == order.invoiceStatus) {
            if (order.invoiceStatus == 306) {
              return this.invoiceStatusOptions[i]['text'] + this.getAllowanceAmount(order)
            } else {
              return this.invoiceStatusOptions[i]['text']
            }
          }
        }
        return ''
      },
      getAllowanceAmount(order) {
        if (!order.invoice) return ''
        if (!order.invoice.allowances) return ''
        var amount = 0
        for (var i = 0; i < order.invoice.allowances.length; i++) {
          amount = amount + order.invoice.allowances[i].amount
        }
        return '(' + amount + ')'
      },
      getInvoiceNumber(order) {
        if (!order.invoice) return ''
        return '(' + order.invoice.number + ')'
      },
      getDeliveryTypeText(type) {
        for (var i = 0; i < this.deliveryTypes.length; i++) {
          if (this.deliveryTypes[i]['type'] == type) {
            return this.deliveryTypes[i]['text']
          }
        }
        return ''
      },
      getPaymentMethodText(method) {
        for (var i = 0; i < this.paymentMethods.length; i++) {
          if (this.paymentMethods[i]['method'] == method) {
            return this.paymentMethods[i]['text']
          }
        }
        return ''
      },
      getInvoiceText(method) {
        for (var i = 0; i < this.invoiceTypes.length; i++) {
          if (this.invoiceTypes[i]['type'] == method) {
            return this.invoiceTypes[i]['text']
          }
        }
        return ''
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validateEdit() {
        var _this = this
        this.$validator.validateAll().then(isValid => {
          if (!isValid) return

          console.log('editForm: ', this.editForm)

          this.processEdit()
          // this.$swal({
          //   title: '沒有設定數量',
          //   text: '請繼續設定數量',
          //   icon: 'warning',
          //   showCancelButton: true,
          //   confirmButtonColor: '#3085d6',
          //   cancelButtonColor: '#d33',
          //   confirmButtonText: '繼續',
          //   cancelButtonText: '離開'
          // }).then((result) => {
          //   if ((result.value) ? false : true) {
          //     this.closeModal('editDialog')
          //   }
          // })

          // this.processReturn()
        })
      },
      async processEdit() {
        var data = await lib.updateOrder(this.editForm.id, this.editForm)
          if (data.status == 0) {
            this.oldOrderVariables.targetOrder.name = this.editForm.name
            this.oldOrderVariables.targetOrder.title = this.editForm.title
            this.oldOrderVariables.targetOrder.mobile = this.editForm.mobile
            this.oldOrderVariables.targetOrder.country = this.editForm.country
            this.oldOrderVariables.targetOrder.area = this.editForm.area
            this.oldOrderVariables.targetOrder.address = this.editForm.address
            this.oldOrderVariables.targetOrder.email = this.editForm.email
            this.oldOrderVariables.targetOrder.note = this.editForm.note
            this.oldOrderVariables.targetOrder.systemNote = this.editForm.systemNote
            this.oldOrderVariables.targetOrder.invoiceType = this.editForm.invoiceType
            this.oldOrderVariables.targetOrder.invoiceInfo = this.editForm.invoiceInfo
            this.oldOrderVariables.targetOrder.status = this.editForm.status

            this.$notify({
              message:`訂單 ${this.editForm.orderNo} 修改完成`,
              icon: 'fa fa-user-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: "success"
            })
            this.closeModal('editDialog')
          } else {
            this.$swal('修改失敗', data.msg, 'error')
          }
      },
      async validateChangeOrderStatus() {
        var _this = this
        this.$validator.validateAll().then(isValid => {
          if (!isValid) return

          // this.$swal({
          //   title: '沒有設定數量',
          //   text: '請繼續設定數量',
          //   icon: 'warning',
          //   showCancelButton: true,
          //   confirmButtonColor: '#3085d6',
          //   cancelButtonColor: '#d33',
          //   confirmButtonText: '繼續',
          //   cancelButtonText: '離開'
          // }).then((result) => {
          //   if ((result.value) ? false : true) {
          //     this.closeModal('allowanceDialog')
          //   }
          // })

          

          this.processChangeOrderStatus()
        })
      },
      async processChangeOrderStatus() {

        console.log('this.orderStatusForm.orders', this.orderStatusForm.orders)
        console.log('this.orderStatusForm.newStatus', this.orderStatusForm.newStatus)

        this.orderStatusForm.orders = this.orderStatusForm.orders.replace(/\s+/g, '')
        this.orderStatusForm.orders = this.orderStatusForm.orders.replace(/(^,)|(,$)/g, "")
        // var orders = this.orderStatusForm.orders.split(",")
        // console.log('orders', orders)
        var result = await tools.confirmDialog(this, "確定進行狀態改變？")
        if (result) {
          this.closeModal('changeStatusDialog')

          var data = {}
          data.orders = this.orderStatusForm.orders
          data.newStatus = this.orderStatusForm.newStatus

          var data2 = await lib.batchChangeStatus(data)
          console.log('data2: ', data2)
          if (data2.status == 0) {
            const orderArray = data.orders.split(",")
            var uniqueOrderArray = [...new Set(orderArray)]

            var successOrderNo = data2.result.updatedOrders
            var failedOrderNo = data2.result.failedOrderNo

            successOrderNo.forEach(order => {
              for (var i = 0; i != uniqueOrderArray.length; i++) {
                if (uniqueOrderArray[i] == order) {
                  uniqueOrderArray.splice(i, 1)
                  break
                }
              }
            })
            console.log('filtered success uniqueOrderArray: ', uniqueOrderArray)

            failedOrderNo.forEach(orderNo => {
              for (var i = 0; i != uniqueOrderArray.length; i++) {
                if (uniqueOrderArray[i] == orderNo) {
                  uniqueOrderArray.splice(i, 1)
                  break
                }
              }
            })
            console.log('filtered failed uniqueOrderArray: ', uniqueOrderArray)

            if (uniqueOrderArray.length != 0) {

            }

            await this.getData()
            if (uniqueOrderArray.length == 0 && failedOrderNo.length == 0) {
              this.$swal('已完成狀態修改', '', 'success')
            } else if (uniqueOrderArray.length != 0 && failedOrderNo.length != 0) {
              this.$swal('已完成狀態修改', '無以下訂單編號: ' + uniqueOrderArray + '<br/>以下訂單無法更改至新狀態: z,y,u', 'success')
            } else if (uniqueOrderArray.length == 0 && failedOrderNo.length != 0) {
              this.$swal('已完成狀態修改', '以下訂單無法更改至新狀態: z,y,u', 'success')
            } else {
              this.$swal('已完成狀態修改', '無以下訂單編號: ' + uniqueOrderArray, 'success')
            }
            // this.$notify({
            //   message:`已完成狀態修改`,
            //   icon: 'fa fa-user-circle',
            //   horizontalAlign: 'right',
            //   verticalAlign: 'bottom',
            //   type: "success"
            // })
          } else {
            console.log('data2: ', data2)
            if (data2.status == 116) {
              this.$swal('失敗', '找不到訂單', 'error')
            } else if (data2.status == 117) {
              this.$swal('失敗', '所有訂單的狀態無法變更為新狀態', 'error')
            } else {
              this.$swal('失敗', data2.msg, 'error')
            }
          }
        }
      },
      async validateAllowance() {
        var _this = this
        this.$validator.validateAll().then(isValid => {
          if (!isValid) return

          var hasAmount = false
          for (var i = 0; i < this.allowanceOrderData.length; i++) {
            if (this.allowanceOrderData[i].amount != 0) {
              hasAmount = true
              break
            }
          }

          if (!hasAmount) {
            this.$swal({
              title: '沒有設定數量',
              text: '請繼續設定數量',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: '繼續',
              cancelButtonText: '離開'
              }).then((result) => {
                if ((result.value) ? false : true) {
                  this.closeModal('allowanceDialog')
                }
              })
          } else {
            var hasNoPrice = false
            for (var i = 0; i < this.allowanceOrderData.length; i++) {
              if (this.allowanceOrderData[i].amount != 0) {
                if (this.allowanceOrderData[i].price == null || this.allowanceOrderData[i].price == 0) {
                  hasNoPrice = true
                  break
                }
              }
            }

            if (hasNoPrice) {
              this.$swal({
                title: '沒有設定含稅單價',
                text: '請繼續設定含稅單價',
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: '繼續',
                // cancelButtonText: '繼續'
                }).then((result) => {
                  // if ((result.value) ? false : true) {
                  //   this.closeModal('allowanceDialog')
                  // }
                })
            } else {
              this.processAllowance()
            }
          }
        })
      },
      async processAllowance() {
        var result = await tools.confirmDialog(this, "確定進行折讓？")
        if (result) {
          this.closeModal('allowanceDialog')
          console.log('allowanceForm: ', this.allowanceForm)
          console.log('allowanceOrderData: ', this.allowanceOrderData)

          var data = {}
          
          var orderItems = []
          for (var i = 0; i < this.allowanceOrderData.length; i++) {
            var allowanceOrderDatum = this.allowanceOrderData[i]
            if (allowanceOrderDatum.amount == 0) {
              continue
            }
            var orderItem = {}
            orderItem.id = allowanceOrderDatum.orderItem.id
            orderItem.number = allowanceOrderDatum.orderItem.item.number
            orderItem.name = allowanceOrderDatum.orderItem.item.name
            orderItem.quantity = allowanceOrderDatum.amount
            orderItem.price = parseFloat(allowanceOrderDatum.price) || 0
            
            orderItems.push(orderItem)
          }
          data.orderItems = orderItems
          console.log('orderId: ', this.allowanceForm.orderId)
          console.log('data: ', data)

          var data2 = await lib.createAllowance(this.allowanceForm.orderId, data)
          console.log('data2: ', data2)
          if (data2.status == 0) {
            await this.getData()
            // this.$swal('已完成', '', 'success')
            this.$notify({
              message:`訂單 ${this.returnForm.orderId} 已完成折讓`,
              icon: 'fa fa-user-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: "success"
            })
          } else {
            console.log('data2: ', data2)
            this.$swal('失敗', '', 'error')
          }
        }
      },
      validateReturn() {
        var _this = this
        this.$validator.validateAll().then(isValid => {
          if (!isValid) return

          var hasAmount = false
          for (var i = 0; i < this.returnOrderData.length; i++) {
            if (this.returnOrderData[i].amount != 0) {
              hasAmount = true
              break
            }
          }

          if (!hasAmount) {
            this.$swal({
              title: '沒有設定數量',
              text: '請繼續設定數量',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: '繼續',
              cancelButtonText: '離開'
              }).then((result) => {
                if ((result.value) ? false : true) {
                  this.closeModal('returnDialog')
                }
              })
          } else {
            this.processReturn()
          }
        })
      },
      async processReturn() {
        var result = await tools.confirmDialog(this, "確定進行退/換貨？")
        if (result) {
          this.closeModal('returnDialog')
          // console.log('returnForm: ', this.returnForm)
          // console.log('returnOrderData: ', this.returnOrderData)
          var data = {}
          data.type = this.returnForm.type
          data.name = this.returnForm.receiverName
          data.mobile = this.returnForm.receiverPhone
          data.address = this.returnForm.receiverAddress
          
          var orderItems = []
          for (var i = 0; i < this.returnOrderData.length; i++) {
            var returnOrderDatum = this.returnOrderData[i]
            if (returnOrderDatum.amount == 0) {
              continue
            }
            var orderItem = {}
            orderItem.id = returnOrderDatum.orderItem.id
            orderItem.quantity = returnOrderDatum.amount
            
            orderItems.push(orderItem)
          }
          data.orderItems = orderItems
          // console.log('orderId: ', this.returnForm.orderId)
          // console.log('data: ', data)

          var data2 = await lib.returnOrder(this.returnForm.orderId, data)
          // console.log('data2: ', data2)
          if (data2.status == 0) {
            await this.getData()
            // this.$swal('已完成', '', 'success')
            this.$notify({
              message:`訂單 ${this.returnForm.orderId} 已新增退/換貨`,
              icon: 'fa fa-user-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: "success"
            })
          } else {
            console.log('data2: ', data2)
            this.$swal('失敗', '', 'error')
          }
        }
      },
      openModal(name) {
        this.modals[name] = true
      },
      closeModal(name) {
        this.modals[name] = false
      },
      async handleNewReturn(order) {
        await this.clearReturnForm()
        this.$validator.errors.clear()

        this.returnForm.orderId = order.id
        this.returnForm.receiverName = order.name
        this.returnForm.receiverAddress = order.address
        this.returnForm.receiverPhone = order.mobile

        // prepare order data
        this.returnOrderData = []
        for (var i = 0; i < order.orderDetails.length; i++) {
          const orderDetail = order.orderDetails[i]
          
          for (var j = 0; j < orderDetail.orderGoods.length; j++) {
            const orderGoods = orderDetail.orderGoods[j]

            for (var k = 0; k < orderGoods.orderItems.length; k++) {
              const orderItem = orderGoods.orderItems[k]
              
              if (orderItem.quantity == 0) {
                continue
              }

              var temp = {}
              temp.refId = orderDetail.refId
              temp.type = orderDetail.type
              
              if (orderDetail.type == 0) {
                // plan
                temp.planName = orderDetail.plan.name
              } else if (orderDetail.type == 1) {
                // add purchase
                temp.planName = orderDetail.addpurchase.name
              }

              temp.orderGoods = orderGoods
              temp.orderItem = orderItem
              var amountArray = []
              for (var l = 0; l <= orderItem.quantity; l++) {
                amountArray.push({'value': l})
              }
              temp.amountArray = amountArray
              temp.amount = 0
              this.returnOrderData.push(temp)
            }
          }
        }

        // this.getSpanArr0(this.returnOrderData)
        // this.getSpanArr1(this.returnOrderData)

        // console.log('this.returnOrderData: ', this.returnOrderData)
        this.openModal('returnDialog')
      },

      async handleAllowance(order) {
        await this.clearAllowanceForm()
        this.$validator.errors.clear()

        this.allowanceForm.orderId = order.id
        this.allowanceForm.receiverName = order.name
        this.allowanceForm.receiverAddress = order.address
        this.allowanceForm.receiverPhone = order.mobile

        // prepare order data
        this.allowanceOrderData = []
        for (var i = 0; i < order.orderDetails.length; i++) {
          const orderDetail = order.orderDetails[i]
          
          for (var j = 0; j < orderDetail.orderGoods.length; j++) {
            const orderGoods = orderDetail.orderGoods[j]

            for (var k = 0; k < orderGoods.orderItems.length; k++) {
              const orderItem = orderGoods.orderItems[k]
              
              if (orderItem.quantity == 0) {
                continue
              }

              var temp = {}
              temp.refId = orderDetail.refId
              temp.type = orderDetail.type
              
              if (orderDetail.type == 0) {
                // plan
                temp.planName = orderDetail.plan.name
              } else if (orderDetail.type == 1) {
                // add purchase
                temp.planName = orderDetail.addpurchase.name
              }

              temp.orderGoods = orderGoods
              temp.orderItem = orderItem
              var amountArray = []
              for (var l = 0; l <= orderItem.quantity; l++) {
                amountArray.push({'value': l})
              }
              temp.amountArray = amountArray
              temp.amount = 0
              // temp.price = 0
              this.allowanceOrderData.push(temp)
            }
          }
        }

        this.openModal('allowanceDialog')
      },

      async handleEdit(order) {
        await this.clearEditForm()
        this.$validator.errors.clear()

        this.oldOrderVariables.targetOrder = order

        this.editForm.id = order.id
        this.editForm.orderNo = order.orderNo
        this.editForm.name = order.name
        this.editForm.title = order.title
        this.editForm.mobile = order.mobile
        this.editForm.country = order.country
        this.editForm.area = order.area
        this.oldOrderVariables.oldCountry = order.country
        this.editForm.address = order.address
        this.editForm.email = order.email
        this.editForm.note = order.note
        this.editForm.systemNote = order.systemNote
        this.editForm.deliveryType = order.deliveryType
        this.editForm.paymentMethod = order.paymentMethod
        this.editForm.totalPrice = order.totalPrice
        this.editForm.currencyId = order.currencyId
        this.editForm.currencyTitle = order.currency.title
        this.editForm.invoiceType = order.invoiceType
        this.oldOrderVariables.oldInvoiceType = order.invoiceType
        this.editForm.invoiceInfo = order.invoiceInfo
        this.editForm.status = order.status
        this.editForm.paymentStatus = order.paymentStatus
        this.editForm.deliveryStatus = order.deliveryStatus
        this.editForm.invoiceStatus = order.invoiceStatus
        // console.log('this.editForm: ', this.editForm)

        // this.buildArea2Options()

        this.openModal('editDialog')
      },
      padLeft(number) {
        if (number < 10) {
          return '0'.concat(number.toString())
        } else {
          return number.toString()
        }
      },
      dateText(str) {
        var d = new Date(str)
        var dformat = [d.getFullYear(), this.padLeft(d.getMonth()+1), this.padLeft(d.getDate())].join('-') + ' ' + [this.padLeft(d.getHours()), this.padLeft(d.getMinutes()), this.padLeft(d.getSeconds())].join(':')

        return dformat
      },
      dateTextForInvoice(str) {
        var d = new Date(str)
        var dformat = [d.getFullYear(), this.padLeft(d.getMonth()+1), this.padLeft(d.getDate())].join('/')

        return dformat
      },
      doSearch() {
        this.pagination.currentPage = 1
        this.query.keyword = this.searchForm.keyword
        this.query.status = this.searchForm.status
        this.query.start_date = this.searchForm.startDt
        this.query.end_date = this.searchForm.endDt
        this.getData()
      },
      executeAction() {
        if (this.actionOptions[0]['action'] === this.actionForm.action) {
          this.checkOrders()
        } else if (this.actionOptions[1]['action'] === this.actionForm.action) {
          this.checkOrders()
        } else if (this.actionOptions[2]['action'] === this.actionForm.action) {
          this.exportCSV2()
        } else {
          console.log('no action')
        }

        this.actionForm.action = null
      },
      async batchChangeStatus() {
        await this.clearOrderStatusForm()
        this.$validator.errors.clear()

        this.openModal('changeStatusDialog')
      },
      exportCSV: function() {
        if (this.$refs.multipleTable.selection.length === 0) {
          this.$swal('請選擇要匯出資料', '', '')
          return
        }

        var exportData = []
        this.$refs.multipleTable.selection.forEach(element => {
          var temp = {}

          temp['通路'] = element.store.name
          temp['訂單編號'] = element.orderNo
          temp['狀態'] = this.getStatusText(element.status) + `(${this.dateText(element.createdAt)})` + '\n' +
                        this.getDeliveryStatusText(element.deliveryStatus)  + '(配送單號)' + '\n' +
                        this.getPaymentStatusText(element.paymentStatus) + `${element.currency.isoCode} ${element.totalPrice}` + '\n' +
                        this.getInvoiceStatusText(element.invoiceStatus) + `(發票號碼)`

          temp['付款/配送'] = `${this.getDeliveryTypeText(element.deliveryType)}\n${this.getPaymentMethodText(element.paymentMethod)}`

          temp['客戶資料'] = `姓名: ${element.name} \n` +
                            `電話: ${element.mobile} \n` +
                            `地址: ${element.address} \n` +
                            `Email: ${element.email} \n` +
                            `發票類型: ${this.getInvoiceText(element.invoiceType)}`

          var tempDetail = []
          element.orderDetails.forEach(detail => {
            var productName = ''
            if (detail.type == 0) {
              productName = detail.plan.name
            } else if(detail.type==1) {
              productName = detail.addpurchase.name
            }
            tempDetail.push(`${productName} ${detail.price} ${element.currency.title}`)

            detail.orderGoods.forEach(orderGoods => {
              orderGoods.goods.goodsDetails.forEach(goodsDetail => {
                tempDetail.push(`${goodsDetail.item.name} * ${orderGoods.quantity * goodsDetail.quantity}`)
              })
            })
          })

          temp['方案/品項'] = tempDetail

          exportData.push(temp)
        })

        var exportString = lib.JSONtoCSV(exportData, ['通路','訂單編號','狀態','方案/品項','付款/配送','客戶資料'])
        var blob = new Blob(['\uFEFF' + exportString], { type: 'text/csv;charset=utf-8;' })
        if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(blob, 'csvname.csv')
        } else {
          saveAs(blob, 'csvname.csv')
        }
      },
      exportCSV2: function() {
        if (this.$refs.multipleTable.selection.length === 0) {
          this.$swal('請選擇要匯出資料', '', '')
          return
        }

        var exportData = []
        this.$refs.multipleTable.selection.forEach(element => {
          var temp = {}

          temp['通路'] = element.store.name
          temp['訂單日期'] = this.dateText(element.createdAt)
          temp['訂單編號'] = element.orderNo
          temp['訂單狀態'] = this.getStatusText(element.status)
          temp['付款狀態'] = this.getPaymentStatusText(element.paymentStatus)
          temp['發票狀態'] = this.getInvoiceStatusText(element.invoiceStatus)
          temp['付款方式'] = this.getPaymentMethodText(element.paymentMethod)
          temp['運送方式'] = this.getDeliveryTypeText(element.deliveryType)
          temp['收件人'] = element.name
          temp['聯絡電話'] = element.mobile
          temp['收件地址'] = this.getAddressText(element)
          temp['Email'] = element.email
          temp['發票類型'] = this.getInvoiceText(element.invoiceType)
          temp['發票載具號碼'] = element.invoiceInfo
          temp['發票號碼'] = element.invoice ? element.invoice.number : ''
          temp['總計金額'] = element.totalPrice

          var items = []
          var counts = []

          var tempDetail = []
          element.orderDetails.forEach(detail => {
            
            detail.orderGoods.forEach(orderGoods => {
              orderGoods.goods.goodsDetails.forEach(goodsDetail => {

                var found = false
                for (var i = 0; i < items.length; i++) {
                  if (items[i].number === goodsDetail.item.number) {
                    // found
                    found = true
                    counts[i] = counts[i] + (orderGoods.quantity * goodsDetail.quantity)
                    break
                  }
                }

                if (!found) {
                  items.push(goodsDetail.item)
                  counts.push(orderGoods.quantity * goodsDetail.quantity)
                }
              })
            })
          })

          for (var i = 0; i < items.length; i++) {
            tempDetail.push(`${items[i].number} * ${counts[i]}`)
          }

          temp['訂購商品'] = tempDetail.join(',')

          exportData.push(temp)
        })

        var exportString = lib.JSONtoCSV(exportData, ['通路','訂單日期','訂單編號','訂單狀態','付款狀態','發票狀態','付款方式','訂購商品','運送方式','收件人','聯絡電話','收件地址','Email','發票類型','發票載具號碼','發票號碼','總計金額'])
        var blob = new Blob(['\uFEFF' + exportString], { type: 'text/csv;charset=utf-8;' })
        if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(blob, 'orders.csv')
        } else {
          saveAs(blob, 'orders.csv')
        }
      },
      async handleIndexChange(page) {
        await this.getData()
      },
      searchByWhere(arr = [], where = {}) {  
        var data = arr.find(function(item) {
          for (var key in where) {
            var val = where[key]
            if (item[key] !== val) return false
          }
          return true
        })
        return data
      },
      // calculateOrderDetailForDisplay(orders) {
      //   // console.log('orders count: ', orders.length)
      //   for (var i = 0; i < orders.length; i++) {
      //     var parentOrder = orders[i]
      //     // console.log(parentOrder.orderNo + ' parentOrder.subOrders count: ', parentOrder.subOrders.length)
      //     if (parentOrder.subOrders.length == 0) {
      //       continue
      //     }
      //     for (var j = parentOrder.subOrders.length - 1; j >= 0 ; j--) {
      //       var subOrder = parentOrder.subOrders[j]
      //       // console.log('subOrder.orderDetails count: ', subOrder.orderDetails.length)
      //       for (var k = 0; k < subOrder.orderDetails.length; k++) {
      //         var orderDetailOfSubOrder = subOrder.orderDetails[k]
      //         var dResult = this.searchByWhere(parentOrder.orderDetails, {'type': orderDetailOfSubOrder.type, 'refId': orderDetailOfSubOrder.refId})
      //         if (!dResult) {
      //           console.log('Error! failed to find a matching plan/addpurchase with refId ' + orderDetailOfSubOrder.refId)
      //           continue
      //         }

      //         // console.log('orderDetailOfSubOrder.orderGoods count: ', orderDetailOfSubOrder.orderGoods.length)
      //         for (var l = 0; l < orderDetailOfSubOrder.orderGoods.length; l++) {
      //           var orderGoodsOfSubOrder = orderDetailOfSubOrder.orderGoods[l]
      //           // console.log('found orderGoods of status ', orderGoodsOfSubOrder.status, ', goodsId ', orderGoodsOfSubOrder.goodsId, ', quantity ', orderGoodsOfSubOrder.quantity)

      //           if (orderGoodsOfSubOrder.status == 0) {
      //             console.log('order goods status NONE, should not go here, ignore')
      //           } else if (orderGoodsOfSubOrder.status == 1 || orderGoodsOfSubOrder.status == 2 || orderGoodsOfSubOrder.status == 3 || orderGoodsOfSubOrder.status == 4) {
      //             // console.log('order goods status RETURNING/RETURNED/EXCHANGING/EXCHANGED')
      //             var subResult = this.searchByWhere(dResult.orderGoods, {'goodsId': orderGoodsOfSubOrder.goodsId})
      //             if (!subResult) {
      //               console.log('Error! failed to find a matching goods with id ' + orderGoodsOfSubOrder.goodsId)
      //               continue
      //             }

      //             if (orderGoodsOfSubOrder.quantity > subResult.quantity) {
      //               console.log('quantity error with goods id ' + orderGoodsOfSubOrder.goodsId)
      //             } else {
      //               // find a target orderGood to add the quantity
      //               var found = false
      //               for (var m = 0; m < dResult.orderGoods.length; m++) {
      //                 var targetOrderGoods = dResult.orderGoods[m]
      //                 if (targetOrderGoods.planDetailId == orderGoodsOfSubOrder.planDetailId &&
      //                   targetOrderGoods.goodsId == orderGoodsOfSubOrder.goodsId && targetOrderGoods.status == orderGoodsOfSubOrder.status) {
      //                   found = true
      //                   targetOrderGoods.quantity = targetOrderGoods.quantity + orderGoodsOfSubOrder.quantity
      //                   break
      //                 }
      //               }

      //               if (!found) {
      //                 dResult.orderGoods.push(orderGoodsOfSubOrder)
      //               }
                    
      //               subResult.quantity = subResult.quantity - orderGoodsOfSubOrder.quantity
      //             }
      //           } else {
      //             console.log('order goods status UNKNOWN, should not go here, ignore')
      //           }
      //         }
      //       }
      //     }
      //   }
      // },
      async getData() {
        this.query.offset = (this.pagination.currentPage - 1) * this.pagination.perPage
        this.query.limit = this.pagination.perPage
        var data = await lib.getOrderList(this.query)
        if (data.status == 0) {
          var result = data.result
          this.pagination.total = result.count
          var orders = result.orders
          orders.sort(function(a,b) {
            // console.log(a.createdAt - b.createdAt)
            return new Date(b.createdAt) - new Date(a.createdAt)
          })

          console.log('orders: ', orders)
          // this.calculateOrderDetailForDisplay(orders)

          this.tableData = orders
        }
      },
      async clearEditForm() {
        var _this = this
        return new Promise(function(resolve, reject) {
          _this.oldOrderVariables.targetOrder = null

          _this.editForm.id = null
          _this.editForm.orderNo = null
          _this.editForm.name = null
          _this.editForm.title = 0
          _this.editForm.mobile = null
          _this.editForm.country = null
          _this.editForm.area = null
          _this.editForm.address = null
          _this.editForm.email = null
          _this.editForm.note = null
          _this.editForm.systemNote = null
          _this.editForm.deliveryType = 0
          _this.editForm.paymentMethod = 0
          _this.editForm.totalPrice = 0
          _this.editForm.currencyId = 0
          _this.editForm.currencyTitle = null
          _this.editForm.invoiceType = 0
          _this.editForm.invoiceInfo = null
          _this.editForm.status = 0
          _this.editForm.paymentStatus = 0
          _this.editForm.deliveryStatus = 0
          _this.editForm.invoiceStatus = 0

          _this.oldOrderVariables.oldCountry = null
          _this.oldOrderVariables.oldInvoiceType = -1

          resolve()
        })
      },
      async clearReturnForm() {
        var _this = this
        return new Promise(function(resolve, reject) {
          _this.returnForm.orderId = ''
          _this.returnForm.type = 0
          _this.returnForm.receiverName = ''
          _this.returnForm.receiverAddress = ''
          _this.returnForm.receiverPhone = ''
          resolve()
        })
      },
      async clearAllowanceForm() {
        var _this = this
        return new Promise(function(resolve, reject) {
          _this.allowanceForm.orderId = ''
          _this.allowanceForm.receiverName = ''
          _this.allowanceForm.receiverAddress = ''
          _this.allowanceForm.receiverPhone = ''
          resolve()
        })
      },
      async clearOrderStatusForm() {
        var _this = this
        return new Promise(function(resolve, reject) {
          _this.orderStatusForm.orders = ''
          _this.orderStatusForm.newStatus = ''
          resolve()
        })
      },
      async handleRenew(props) {
        var result = await tools.confirmDialog(this, `處理完成了嗎？`)
        if (result) {
          var data = await lib.updateOrder(props.row.id, {'status': 0})
          if (data.status == 0) {
            this.tableData[props.$index].status = 0
            this.$notify({
              message:`訂單 ${props.row.orderNo} 已處理完成`,
              icon: 'fa fa-user-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: "success"
            })
          } else {
            this.$swal('處理失敗', data.msg, 'error')
          }
        }
      },
      async handleStock(out, props) {
        var result = await tools.confirmDialog(this, out ? `確定設定為缺貨？` : `確定設定為可出貨？`)
        if (result) {
          var data = await lib.updateOrder(props.row.id, out ? {'status': 3, 'deliveryStatus': 102} : {'status': 0, 'deliveryStatus': 101})
          if (data.status == 0) {
            this.tableData[props.$index].status = out ? 3 : 0
            this.tableData[props.$index].deliveryStatus = out ? 102 : 101
            this.$notify({
              message: `訂單 ${props.row.orderNo} 已設為` + (out ? '缺貨' : '可出貨'),
              icon: 'fa fa-user-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: "success"
            })
          } else {
            this.$swal('處理失敗', data.msg, 'error')
          }
        }
      },
      async handleUpload(props) {
        var result = await tools.confirmDialog(this, `確定要上傳訂單？`)
        if (result) {
          // default main order
          var newStatus = 2
          var newDeliveryStatus = 104
          if (props.row.status == 400) {
            newStatus = 403
            newDeliveryStatus = 503
          } else if (props.row.status == 401) {
            newStatus = 404
            newDeliveryStatus = 503
          }
          var data = await lib.updateOrder(props.row.id, {'status': newStatus, 'deliveryStatus': newDeliveryStatus})
          if (data.status == 0) {
            this.tableData[props.$index].status = newStatus
            this.tableData[props.$index].deliveryStatus = newDeliveryStatus
            this.$notify({
              message: `訂單 ${props.row.orderNo} 已上傳`,
              icon: 'fa fa-user-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: "success"
            })
          } else {
            this.$swal('上傳失敗', data.msg, 'error')
          }
        }
      },
      async handleDeliver(props) {
        var result = await tools.confirmDialog(this, `處理完成了嗎？`)
        if (result) {
          var data = await lib.updateOrder(props.row.id, {'deliveryStatus': 105})
          if (data.status == 0) {
            this.tableData[props.$index].deliveryStatus = 105
            this.$notify({
              message:`訂單 ${props.row.orderNo} 已出貨`,
              icon: 'fa fa-user-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: "success"
            })
          } else {
            this.$swal('處理失敗', data.msg, 'error')
          }
        }
      },
      async handleDeny(props) {
        var result = await tools.confirmDialog(this, `設為拒收？`)
        if (result) {
          var data = await lib.updateOrder(props.row.id, {'status': 7, 'deliveryStatus': 107})
          if (data.status == 0) {
            this.tableData[props.$index].status = 7
            this.tableData[props.$index].deliveryStatus = 107
            this.$notify({
              message: `訂單 ${props.row.orderNo} 已設為拒收`,
              icon: 'fa fa-user-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: "success"
            })
          } else {
            this.$swal('處理失敗', data.msg, 'error')
          }
        }
      },
      async handleOthers(props) {
        var result = await tools.confirmDialog(this, `設為其他狀態？`)
        if (result) {
          var data = await lib.updateOrder(props.row.id, {'status': 2, 'deliveryStatus': 108})
          if (data.status == 0) {
            this.tableData[props.$index].status = 2
            this.tableData[props.$index].deliveryStatus = 108
            this.$notify({
              message: `訂單 ${props.row.orderNo} 已設為其他狀態`,
              icon: 'fa fa-user-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: "success"
            })
          } else {
            this.$swal('處理失敗', data.msg, 'error')
          }
        }
      },
      async handleArrive(props) {
        var result = await tools.confirmDialog(this, `設為已到貨？`)
        if (result) {
          var data = await lib.updateOrder(props.row.id, {'status': 4, 'deliveryStatus': 106})
          if (data.status == 0) {
            this.tableData[props.$index].status = 4
            this.tableData[props.$index].deliveryStatus = 106
            this.$notify({
              message: `訂單 ${props.row.orderNo} 已設為已到貨`,
              icon: 'fa fa-user-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: "success"
            })
          } else {
            this.$swal('處理失敗', data.msg, 'error')
          }
        }
      },
      async handleReturnFinish(props) {
        var result = await tools.confirmDialog(this, `設為完成退/換貨？`)
        if (result) {
          var newStatus = 406
          var newDeliveryStatus = 504
          if (props.row.status == 404) {
            newStatus = 407
            newDeliveryStatus = 505
          }
          var data = await lib.updateOrder(props.row.id, {'status': newStatus, 'deliveryStatus': newDeliveryStatus})
          if (data.status == 0) {
            await this.getData()
            // this.tableData[props.$index].status = newStatus
            // this.tableData[props.$index].deliveryStatus = newDeliveryStatus
            this.$notify({
              message: `訂單 ${props.row.orderNo} 已設為已` + (props.row.status == 404 ? '退貨' : '換貨'),
              icon: 'fa fa-user-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: "success"
            })
          } else {
            this.$swal('處理失敗', data.msg, 'error')
          }
        }
      },
      async handlePayment(props) {
        var result = await tools.confirmDialog(this, `設為已付款？`)
        if (result) {
          var newPaymentStatus = 202
          var newInvoiceStatus = 301
          var data = await lib.updateOrder(props.row.id, {'paymentStatus': newPaymentStatus, 'invoiceStatus': newInvoiceStatus})
          if (data.status == 0) {
            this.tableData[props.$index].paymentStatus = newPaymentStatus
            this.tableData[props.$index].invoiceStatus = newInvoiceStatus
            this.$notify({
              message: `訂單 ${props.row.orderNo} 已設為已付款`,
              icon: 'fa fa-user-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: "success"
            })
          } else {
            this.$swal('處理失敗', data.msg, 'error')
          }
        }
      },
      async handleIssueInvoice(props) {
        var result = await tools.confirmDialog(this, `確定開立發票？`)
        if (result) {
          ///
          // var invoice = {}
          // invoice.OrderId = props.row.orderNo
          // invoice.OrderDate = this.dateTextForInvoice(props.row.createdAt)
          // // invoice.OrderId = props.row.orderNo
          // // invoice.OrderId = props.row.orderNo
          // // invoice.OrderId = props.row.orderNo
          // // invoice.OrderId = props.row.orderNo
          // // invoice.OrderId = props.row.orderNo
          // // await tools.confirmDialog(this, invoice)
          // // this.$swal(JSON.stringify(invoice), '', 'success')
          // console.log('invoice: ', invoice)
          ///



          // var newInvoiceStatus = 302
          var data = await lib.issueInvoice(props.row.id)
          if (data.status == 0) {
            // this.tableData[props.$index].invoiceStatus = newInvoiceStatus
            await this.getData()
            this.$notify({
              message: `訂單 ${props.row.orderNo} 已開立發票`,
              icon: 'fa fa-user-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: "success"
            })
          } else {
            this.$swal('處理失敗', data.msg, 'error')
          }
        }
      },
      async handleCancelInvoice(props) {
        var result = await tools.confirmDialog(this, `確定作廢發票？`)
        if (result) {
          // var newInvoiceStatus = 305
          var data = await lib.cancelInvoice(props.row.id)
          if (data.status == 0) {
            // this.tableData[props.$index].invoiceStatus = newInvoiceStatus
            await this.getData()
            this.$notify({
              message: `訂單 ${props.row.orderNo} 發票已作廢`,
              icon: 'fa fa-user-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: "success"
            })
          } else {
            this.$swal('處理失敗', data.msg, 'error')
          }
        }
      },
      async handleDelete(id, props) {
        var result = await tools.confirmDialog(this, "確定要刪除？")
        if (result) {
          var data = await lib.deleteItem(id)
          if (data.status == 0) {
            await this.getData()
            this.$swal('已刪除', '', 'success')
          } else {
            this.$swal('刪除失敗', '', 'error')
          }
        }
      },
      async checkOrders() {
        var data = await lib.checkOrders(this.actionForm)
        if (data.status == 0) {
          this.getData()
        } else {
          console.log('failed to check orders')
        }
      },
      async toggleSubOrders(props) {
        var index = props.$index
        var show = false
        if (this.tableData.length == index + 1) {
          show = true
        } else {
          var order = this.tableData[index + 1]
          if (order.parentId) {
            show = false
          } else {
            show = true
          }
        }
        if (show) {
          this.tableData.splice(props.$index + 1, 0, ...props.row.subOrders)
        } else {
          while (index < this.tableData.length - 1) {
            index++
            var order = this.tableData[index]
            if (!order.parentId) {
              break
            }
          }

          const length = index - props.$index
          this.tableData.splice(props.$index + 1, length)
        }
      }
    }
  }
</script>


<style>
.toolsBar {
  justify-content: space-between;
  display: flex;
}

.leftTools {
  display: flex;
}

.leftTools > * {
  padding-right: 10px;
}

.btn:focus,.btn:active {
   outline: none !important;
   /* box-shadow: none; */
}
</style>
